export const showcase = [
    {
        url: 'https://res.cloudinary.com/dltyzpjet/image/upload/v1752763263/MaximalShowcase/luxury_tile_bath1_chtnpk.png',
        title: 'Project Gallery - 1',
        description: 'Tile Floor and Shower Surround'
    },
    {
        url: 'https://res.cloudinary.com/dltyzpjet/image/upload/v1752763263/MaximalShowcase/blue_tile_surround1_gaoqhm.png',
        title: 'Project Gallery - 2',
        description: 'Blue Tile Surround'
    },
    {
        url: 'https://res.cloudinary.com/dltyzpjet/image/upload/v1752765074/MaximalShowcase/Backsplash_Star_Pattern1_oqsi8y.png',
        title: 'Project Gallery - 3',
        description: 'Backsplash'
    },
    {
        url: 'https://res.cloudinary.com/dltyzpjet/image/upload/v1752764568/MaximalShowcase/Shower_Tile_Deco_Niche1_wpp5yl.png',
        title: 'Project Gallery - 4',
        description: 'Shower Tile with Niche'
    },
    {
        url: 'https://res.cloudinary.com/dltyzpjet/image/upload/v1752764570/MaximalShowcase/Shower_Tile_Stripes1_nqhoxz.png',
        title: 'Project Gallery - 5',
        description: 'Shower Tile with Stripes'
    },
    {
        url: 'https://res.cloudinary.com/dltyzpjet/image/upload/v1752765319/MaximalShowcase/Modern_Bath_Gray_rhq7kw.png',
        title: 'Project Gallery - 6',
        description: 'Modern Bathroom'
    }
];